import React from "react";
import { Dialog } from "../../ui/Dialog";
import { PendingListMove } from "./useListMoveConfirm";

interface ListMoveConfirmDialogProps {
  pending: PendingListMove;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The two confirmations item 6 calls for. Copy varies by `pending.kind`;
 * the shell otherwise matches DeleteConfirmDialog's plain-confirm branch.
 */
const ListMoveConfirmDialog: React.FC<ListMoveConfirmDialogProps> = ({
  pending,
  onConfirm,
  onCancel,
}) => {
  const title =
    pending.kind === "into-shared" ? "Move into a shared list?" : "Move out of this shared list?";
  const body =
    pending.kind === "into-shared" ? (
      <>
        Moving this task into <strong>{pending.targetLabel}</strong> will make it visible to
        everyone on that list.
      </>
    ) : (
      <>
        This task is visible to everyone on this shared list. Moving it to{" "}
        <strong>{pending.targetLabel}</strong> will remove it from their view.
      </>
    );

  return (
    <Dialog
      onClose={onCancel}
      label={title}
      backdropClassName="z-40"
      panelClassName="w-full max-w-md"
    >
      <h3 className="text-lg font-semibold text-warm-text-primary mb-3">{title}</h3>
      <p className="text-warm-text-secondary text-sm mb-6">{body}</p>
      <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3">
        <button
          onClick={onCancel}
          className="w-full sm:w-auto px-4 py-2 text-warm-text-secondary hover:text-warm-text-primary transition-colors text-sm"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="w-full sm:w-auto px-4 py-2 bg-warm-blue hover:bg-warm-blue-dark text-white rounded-soft text-sm transition-colors"
        >
          Move
        </button>
      </div>
    </Dialog>
  );
};

export default ListMoveConfirmDialog;
